import {
  DocumentInfo,
  getDocumentsUploadStatusForStatus,
} from "../../../../../constants/statusToDocMap/docUploadMap";
import { JCodeDocuments } from "../../../../../data-model/medicalPaOrdersModel";
import { getDocumentTypeDisplayName } from "../documentsTable";

export const checkifAllDocsAreUploaded = (
  authStatus?: string,
  docsFromDB?: JCodeDocuments[],
  jCodeId?: string,
  jCode?: string,
) => {
  const docsForStatus = getDocumentsUploadStatusForStatus(authStatus);

  if (
    docsFromDB &&
    docsFromDB.length > 0 &&
    docsForStatus &&
    docsForStatus.length > 0
  ) {
    return docsForStatus.map((doc) => {
      const docFromDocs = docsFromDB?.find(
        (d) => d?.doc_type === doc?.doc_type && d?.doc_path !== "",
      );

      return {
        ...doc,
        isUploaded: docFromDocs?.doc_path && docFromDocs?.doc_path !== "",
        doc_path: docFromDocs?.doc_path || "",
        doc_id: jCodeId || "",
        doc_title: docFromDocs?.doc_title || "",
        j_code: jCode || "",
        uploaded_text: docFromDocs?.doc_title || "",
      };
    });
  }

  return docsForStatus;
};

export const getDocsNotBelongingToCurrentAuthStatus = (
  authStatus: string,
  docsFromDB: JCodeDocuments[],
  jCode?: string,
  jCodeId?: string,
): DocumentInfo[] => {
  const docsForStatus = getDocumentsUploadStatusForStatus(authStatus);

  const docsNotBelongingToCurrentAuthStatus = docsFromDB.filter(
    (doc) =>
      doc?.doc_path !== "" &&
      !docsForStatus.some((d) => d?.doc_type === doc?.doc_type),
  );

  return docsNotBelongingToCurrentAuthStatus.map((doc) => ({
    isUploaded: doc?.doc_path && doc?.doc_path !== "" ? true : false,
    doc_type: doc?.doc_type || "",
    doc_upload_date: doc?.doc_upload_date || "",
    doc_upload_by: doc?.doc_upload_by || "",
    doc_path: doc?.doc_path || "",
    doc_id: jCodeId || "",
    doc_title: doc?.doc_title || "",
    uploaded_text: doc?.doc_title || "",
    text_to_display: getDocumentTypeDisplayName(doc?.doc_type || ""),
    j_code: jCode || "",
  }));
};
